import { render, staticRenderFns } from "./AmplifyAuth.vue?vue&type=template&id=4d7faad8&"
import script from "./AmplifyAuth.vue?vue&type=script&lang=js&"
export * from "./AmplifyAuth.vue?vue&type=script&lang=js&"
import style0 from "./AmplifyAuth.vue?vue&type=style&index=0&id=4d7faad8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports